var map = {
	"./bg-BG.json": 2443,
	"./ca-ES.json": 2444,
	"./cs-CZ.json": 2445,
	"./de-DE.json": 2446,
	"./el-GR.json": 2447,
	"./en-US.json": 1225,
	"./es-ES.json": 2448,
	"./et-EE.json": 2449,
	"./fi-FI.json": 2450,
	"./fr-FR.json": 2451,
	"./he-IL.json": 2452,
	"./it-IT.json": 2453,
	"./ja-JP.json": 2454,
	"./ko-KR.json": 2455,
	"./nb-NO.json": 2456,
	"./nl-NL.json": 2457,
	"./nn-NO.json": 2458,
	"./pl-PL.json": 2459,
	"./pt-BR.json": 2460,
	"./ro-RO.json": 2461,
	"./ru-RU.json": 2462,
	"./sk-SK.json": 2463,
	"./sv-SE.json": 2464,
	"./tr-TR.json": 2465,
	"./zh-CN.json": 2466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2442;